/*
  Customily 上传照片区增强：只在产品有「上传照片」选项时生效。
  - 给定制区外框打 has-photo-upload 类，样式见 customily-photo-upload.css
  - 在每个上传选项的标题旁插入「View Photo Guide」，点开共用的照片指南弹窗

  为什么用 MutationObserver 而不是等某个事件：
  Customily 的选项是 Vue 异步渲染的，切换变体、条件选项显隐时整块会重建，
  插入的链接可能被冲掉。每次 DOM 变化都幂等地补一遍最稳。

  为什么只往 label 末尾追加节点、不改里面的文字：
  改 Vue 管理的文本节点会在它下一次补丁时错乱；末尾追加的外来节点 Vue 不会去动。

  联系页地址由 theme.liquid 通过 data-contact-url 传入（两店页面 handle 不同）。
*/
(function () {
  'use strict';

  var CONTAINER_SELECTOR = '.gradette-personalized-container';
  var UPLOAD_SELECTOR = '.customily-file-input';
  var LINK_CLASS = 'photo-guide-link';
  var HAS_UPLOAD_CLASS = 'has-photo-upload';

  var scriptEl = document.currentScript;
  var contactUrl = (scriptEl && scriptEl.dataset.contactUrl) || '/';

  // 与预览图下方 Customily 调整按钮同顺序：放大、缩小、旋转、上、下、左、右
  var GUIDE_ICON_PATHS = [
    '<circle cx="11" cy="11" r="7"/><path d="m20 20-4-4M11 8v6M8 11h6"/>',
    '<circle cx="11" cy="11" r="7"/><path d="m20 20-4-4M8 11h6"/>',
    '<path d="M3 12a9 9 0 1 0 3-6.7L3 8"/><path d="M3 3v5h5"/>',
    '<path d="M12 19V5M5 12l7-7 7 7"/>',
    '<path d="M12 5v14M19 12l-7 7-7-7"/>',
    '<path d="M19 12H5M12 19l-7-7 7-7"/>',
    '<path d="M5 12h14M12 5l7 7-7 7"/>'
  ];
  var GUIDE_ICONS = GUIDE_ICON_PATHS.map(function (d) {
    return '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' + d + '</svg>';
  }).join('');

  var modal = null;
  var lastTrigger = null;

  function buildModal() {
    var el = document.createElement('div');
    el.className = 'photo-guide-modal';
    el.hidden = true;
    el.innerHTML =
      '<div class="photo-guide-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="photo-guide-title">' +
        '<button type="button" class="photo-guide-modal__close" aria-label="Close">&times;</button>' +
        '<h2 class="photo-guide-modal__title" id="photo-guide-title">Photo Guide</h2>' +
        '<ol class="photo-guide-modal__steps">' +
          '<li>Pick a clear, well-lit photo and crop it close to the subject before uploading. Larger, high-resolution photos print best.</li>' +
          '<li>Tap <strong>Select Photo</strong> to upload. Want a different one? Tap <strong>Replace</strong>.</li>' +
          '<li>Use the buttons under the preview to zoom, rotate or move your photo (or tap <strong>Crop</strong> to reframe it), then tap <strong>Preview Your Design</strong> to check everything before adding to cart.' +
            '<div class="photo-guide-modal__icons" aria-hidden="true">' + GUIDE_ICONS + '</div></li>' +
          '<li>Processing a photo can take 20&ndash;30 seconds. If it still won\'t upload, go ahead and check out, then send us your order number and photo through our <a class="photo-guide-modal__contact">Contact page</a> and we\'ll finish your order by hand.</li>' +
        '</ol>' +
      '</div>';
    el.querySelector('.photo-guide-modal__contact').href = contactUrl;

    el.addEventListener('click', function (e) {
      // 点遮罩或关闭按钮都关闭；点对话框内部不关
      if (e.target === el || e.target.closest('.photo-guide-modal__close')) closeModal();
    });
    document.body.appendChild(el);
    return el;
  }

  function onKeydown(e) {
    if (e.key === 'Escape') closeModal();
  }

  function openModal(trigger) {
    modal = modal || buildModal();
    lastTrigger = trigger;
    modal.hidden = false;
    document.body.classList.add('photo-guide-open');
    document.addEventListener('keydown', onKeydown);
    modal.querySelector('.photo-guide-modal__close').focus();
  }

  function closeModal() {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    document.body.classList.remove('photo-guide-open');
    document.removeEventListener('keydown', onKeydown);
    // 弹窗打开期间 Vue 可能重建了选项，原按钮已不在页面上，就把焦点交给现有的那个
    var target = lastTrigger && lastTrigger.isConnected ? lastTrigger : document.querySelector('.' + LINK_CLASS);
    if (target) target.focus();
  }

  function createLink() {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = LINK_CLASS;
    btn.setAttribute('aria-label', 'View Photo Guide');
    btn.innerHTML = '<i class="photo-guide-link__icon" aria-hidden="true">i</i><span>View Photo Guide</span>';
    btn.addEventListener('click', function (e) {
      // label 自身是 Customily 的折叠触发器，阻止冒泡避免连带展开/收起
      e.preventDefault();
      e.stopPropagation();
      openModal(btn);
    });
    return btn;
  }

  function enhance() {
    var containers = document.querySelectorAll(CONTAINER_SELECTOR);
    for (var i = 0; i < containers.length; i++) {
      var container = containers[i];
      var uploads = container.querySelectorAll(UPLOAD_SELECTOR);
      // 上传位被条件选项移除（v-if）时类名跟着撤掉，外观回到默认
      container.classList.toggle(HAS_UPLOAD_CLASS, uploads.length > 0);

      for (var j = 0; j < uploads.length; j++) {
        var option = uploads[j].closest('.customily_option');
        var label = option && option.querySelector(':scope > label');
        if (label && !label.querySelector('.' + LINK_CLASS)) label.appendChild(createLink());
      }
    }
  }

  var scheduled = false;
  function scheduleEnhance() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      enhance();
    });
  }

  new MutationObserver(scheduleEnhance).observe(document.body, { childList: true, subtree: true });
  scheduleEnhance();
})();
